import { render, staticRenderFns } from "./DataFormSection.vue?vue&type=template&id=fb9c61ae&"
import script from "./DataFormSection.vue?vue&type=script&lang=js&"
export * from "./DataFormSection.vue?vue&type=script&lang=js&"
import style0 from "./DataFormSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports